import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import List from "./list";
import ListDetailsSubLayout from "../../layout/ListDetailSubLayout";
import Details from "./details";
import useCommonStore from "../../stores/common";
import useTicketStore from "../../stores/ticket";
import toast, { ToastBar, Toaster } from "react-hot-toast";
import { fetchTicketOptions } from "../../services/ticket";
import style from "./styles.module.scss";
import CloseIconWhite from "../../assets/svg/icons/common/CloseIconWhite";

const TicketsPage = ({ match, location }) => {
  const setMerchantTicketScope = useTicketStore(
    (state) => state.setMerchantTicketScope,
  );

  useEffect(() => {
    const id = parseInt(match.params.powerappId, 10);
    setMerchantTicketScope(
      Number.isInteger(id) ? id : null,
      Number.isInteger(id) ? (location.state?.merchantDba ?? null) : null,
    );
  }, [
    match.params.powerappId,
    location.state?.merchantDba,
    setMerchantTicketScope,
  ]);

  useEffect(() => {
    fetchTicketOptions().catch(console.error);

    return () => {
      useCommonStore.getState().reset();
      useTicketStore.getState().reset();
    };
  }, []);

  return (
    <>
      <ListDetailsSubLayout listComponent={List} detailsComponent={Details} />
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            borderRadius: "8px",
            background: "rgba(40, 39, 45, 0.85)",
            color: "#fff",
            padding: "16px 24px",
          },
          duration: 5000,
        }}
      >
        {(t) => (
          <ToastBar toast={t}>
            {({ icon, message }) => (
              <>
                {icon}
                {message}
                {t.type !== "loading" && (
                  <button
                    type="button"
                    className={style.toast_dismissal_button}
                    onClick={() => toast.dismiss(t.id)}
                  >
                    <CloseIconWhite />
                  </button>
                )}
              </>
            )}
          </ToastBar>
        )}
      </Toaster>
    </>
  );
};

export default withRouter(TicketsPage);
